import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class SubscriptionApplicationService {
  // 分页查询订阅申请列表
  static async getList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/SubscribeApply?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增订阅申请
  static async addSubscribeApply(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/SubscribeApply', payload))
    return Callback(err, res)
  }
  // 查看订阅申请详情
  static async readSubscribeApply(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/std/SubscribeApply/${payload}`))
    return Callback(err, res)
  }
  // 删除订阅申请
  static async delSubscribeApply(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/SubscribeApply/many', { data: payload })
    )
    return Callback(err, res)
  }
  // 分页查询申请详情分页结果
  static async getApplyDetailPagedResult(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/SubscribeApply/apply-detail-paged-result?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 编辑订阅申请
  static async updateSubscribeApply(id, payload) {
    const [err, res] = await To(wizStandardInstance.put(`/api/std/SubscribeApply/${id}`, payload))
    return Callback(err, res)
  }
  // 批量审核
  static async approved(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/std/SubscribeApply/approved', payload)
    )
    return Callback(err, res)
  }
}
